const getUrl = ()=>{
	const hostArr = window.location.hostname.split('.')
	let str = 'https://'
	hostArr.forEach((host,k) => {
			if ( k === 0 ) {
					str += `api`
			}else{
					str += `.${host}`
			}

	})
	return str
}

export default {
	baseUrl: process.env.NODE_ENV ==='development' ? 'https://api.ive-global.com' : getUrl(),
	// baseUrl: process.env.NODE_ENV ==='development' ? 'http://192.168.0.29:8081' : getUrl(),
	version: '1.0.0',
	tokenKey: 'cx-token',
	userInfoKey: 'cx-userInfo'
}
